export enum PaymentProvider {
  Adyen = 'adyen',
}
